@if (forms$ | async; as forms) {
  <div class="fixed bottom-0 w-full pt-0">
    <div [ngClass]="{ hidden: displayMenu }" class="bg-white">
      <div class="border-b border-b-[#E6E6E6] flex flex-row justify-between p-4">
        <p class="text-2xl">Menu</p>
        <a (click)="toggleMenu()"
          ><svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              fill="currentColor"
              d="m8.382 17.025l-1.407-1.4L10.593 12L6.975 8.4L8.382 7L12 10.615L15.593 7L17 8.4L13.382 12L17 15.625l-1.407 1.4L12 13.41z"
            /></svg
        ></a>
      </div>
      <div class="flex flex-col gap-1 items-start p-4 z-99999">
        @for (form of forms; track form.id) {
          <button (click)="resetForm()" [routerLink]="['/forms', form.id]" class="text-[#0C0C66]">
            <span>{{ form.name }}</span>
          </button>
        } @empty {
          <div>Aucun formulaire disponible.</div>
        }

        <button (click)="logout()" class="text-red-400">
            <span>Déconnexion</span>
          </button>
      </div>
    </div>
    <div class="absolute w-fit left-[41%] top-[-40%]" [ngClass]="{ hidden: !displayMenu }">
      <img
        src="/assets/images/logo-menu.png"
        alt=""
        class="rounded-full bg-white"
        (click)="toggleMenu()"
      />
    </div>
    <div class="bg-white h-25 flex justify-between items-center p-5 pb-8 [&>*:nth-child(2)]:mr-6">
      @for (form of forms.filter((f) => f.in_bottom); track form.id) {
        <button
          (click)="resetForm()"
          [routerLink]="['/forms', form.id]"
          class="rounded-xl text-center flex flex-col justify-center items-center w-16.25"
        >
          @if (form.icon) {
            <span [innerHTML]="form.icon" class="text-[32px] text-gray-400"></span>
          } @else {
            <svg
              class="text-[32px] text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                fill="currentColor"
                d="M6 21q-1.25 0-2.125-.875T3 18v-6q0-.6.225-1.15t.65-.975l6-6q.425-.45.988-.663T12 3t1.125.213t1 .662l.75.75L7 12.5V17h10v-4.5l-3.6-3.6l2.875-2.85l3.85 3.825q.425.425.65.975T21 12v6q0 1.25-.875 2.125T18 21z"
              />
            </svg>
          }
          <span>{{ form.name }}</span>
        </button>
      } @empty {
        <div>Aucun formulaire disponible.</div>
      }
    </div>
  </div>
} @else {
  <div>Chargement des formulaires...</div>
}
